import React from 'react';
import { Reveal } from './Reveal';
type Review = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const reviews: Review[] = [{
  initials: 'MF',
  quote: 'I opened Volume 2 on a Friday night and gave the best step class of my career on Saturday morning. My students asked me what had changed. The answer was: everything.',
  name: 'Michelle F.',
  role: 'Sydney, Australia · Step Aerobics Instructor'
}, {
  initials: 'NG',
  quote: 'The 45° Protocol changed everything about how I teach ascents. Three weeks in, two of my long-term students told me they finally felt it in their glutes instead of their knees. That feedback was worth 10 times the price.',
  name: 'Nicole G.',
  role: 'Toronto, Canada · Group Fitness & Step Coach'
}, {
  initials: 'AL',
  quote: 'I used the low-impact adaptation protocols for a senior client with limited knee mobility. She told me it was the first step class she had ever been able to complete without pain. This system genuinely works.',
  name: 'Amanda L.',
  role: 'Manchester, UK · Step & Fitness Instructor'
}];
export function Reviews() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-199" data-mp="2hehq34npxuln">
      <div className="mx-auto max-w-6xl" data-id="element-200" data-mp="2hezsyk4vz72j">
        <Reveal className="text-center" data-id="element-201" data-mp="2dd5wyp5myr8p">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl" data-id="element-202" data-mp="2de7k3rzxf46s">
            ⭐ More Real Results from <span className="text-green-dark" data-id="element-203" data-mp="3a59idr1nxz3p">Real Instructors</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-204" data-mp="354lrr6hcjka0">4.9/5 · Over 500 instructors already teaching with a real system.</p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-205" data-mp="30azebc3czcd5">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.05} data-id="element-206" data-mp="2w9xm3f7v00ko" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-ink/10 bg-mist p-7 shadow-premium" data-id="element-207" data-mp="3sv7po4xmzo6a">
                <div className="text-green" data-id="element-208" data-mp="3o0tpzqbxyuvt">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-209" data-mp="1m54dh55xry64">“{review.quote}”</blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-210" data-mp="1r35w5ozg9vh2">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sky text-sm font-bold text-teal" data-id="element-211" data-mp="1cg4e3kniv0re">
                    {review.initials}
                  </span>
                  <span data-id="element-212" data-mp="13f65ep25252h">
                    <span className="block font-bold text-ink" data-id="element-213" data-mp="13dv2ergip1cf">{review.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-214" data-mp="18eitte8nrk76">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}